<span class="arrow" [ngSwitch]="direction">
  <i *ngSwitchCase="'N'" class="fa-solid fa-arrow-up"></i>
  <i *ngSwitchCase="'NE'" class="fa-solid fa-arrow-up-right"></i>
  <i *ngSwitchCase="'NW'" class="fa-solid fa-arrow-up-left"></i>
  <i *ngSwitchCase="'S'" class="fa-solid fa-arrow-down"></i>
  <i *ngSwitchCase="'SE'" class="fa-solid fa-arrow-down-right"></i>
  <i *ngSwitchCase="'SW'" class="fa-solid fa-arrow-down-left"></i>
  <i *ngSwitchCase="'E'" class="fa-solid fa-arrow-right"></i>
  <i *ngSwitchCase="'W'" class="fa-solid fa-arrow-left"></i>
</span>
